;(function (window) {
    window.YuiDetector = {
        isOperaMini: function() {
            return navigator.userAgent.match(/Opera Mini/i);
        }
    };
})(window);